import styles from './Footer.scss';
import { getAppConfig } from 'common/util/configUtil';

function getReleaseValue(){
    const { complionEnterpriseRelease } = getAppConfig();
    return complionEnterpriseRelease;
}

const Footer = () => (
    <div className={styles.secondaryText} data-cy="Footer">
        <p>
            <span>{'Don\'t have an account? '}</span>
            <a href="https://complion.com/" data-cy="Footer-Learn">Learn More</a>
        </p>

        <p className={styles.releaseText} data-cy="Footer-Version">
          Version: { getReleaseValue() }
        </p>
        <p>
            &nbsp;
        </p>
        <p>
            <a href="https://complion.com/complion-privacy-statement/" data-cy="Footer-Privacy">Complion Privacy Statement</a>
        </p>
    </div>
);

export default Footer;
